import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogModule } from '../dialog/dialog.module';
import { FeaturesModule } from '../features/features.module';
import { FormMasterModule } from '../form-master/form-master.module';
import { SharedModule } from '../shared/shared.module';
import { AttachmentBuilder } from './attachment.builder';
import { AttachmentsService } from './attachments.service';
import { AttachmentsStore } from './attachments.store';
import { AddAttachmentsComponent } from './components/add-attachments/add-attachments.component';
import { AttachmentViewDialogComponent } from './components/attachment-view-dialog/attachment-view-dialog.component';
import { AttachmentsUploadingListItemComponent } from './components/attachments-uploading-list-item/attachments-uploading-list-item.component';
import { AttachmentsUploadingListComponent } from './components/attachments-uploading-list/attachments-uploading-list.component';

const components = [
  AddAttachmentsComponent,
  AttachmentsUploadingListComponent,
  AttachmentsUploadingListItemComponent,
  AttachmentViewDialogComponent,
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    DialogModule,
    FeaturesModule,
    FormMasterModule,
  ],
  declarations: [...components],
  exports: [...components],
  providers: [AttachmentsStore, AttachmentBuilder, AttachmentsService],
})
export class AttachmentsModule {}
